import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { Modal } from "@faire/web--source/slate/Modal";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailersFilterInteraction } from "@faire/web-api--source/events/retailers/actionUnknown/filterInteraction";
import React from "react";
import styled from "styled-components";

import { FilterBar } from "../FilterBar";
import { useFilterStore } from "../useFilterStore";

import { IFilterModalProps } from ".";

export const FilterModal: React.FC<IFilterModalProps> = ({
  name,
  resultsCount,
  isLoading,
  children,
}) => {
  const {
    data: { isMobileModalOpen, isNewFilterSelected },
    setFilterState,
  } = useFilterStore([
    "isSideBarVisible",
    "isMobileModalOpen",
    "isNewFilterSelected",
  ]);

  const handleModalClose = () => {
    trackRetailersFilterInteraction(name, "close_filters", "modal");
    setFilterState((currentState) => ({
      ...currentState,
      isMobileModalOpen: false,
      isNewFilterSelected: false,
    }));
  };

  return (
    <Modal
      isOpen={isMobileModalOpen}
      showCloseButton
      onClose={handleModalClose}
      data-test-id={`${name}-filter-modal`}
      padding={getSpacing("7x", 12)}
    >
      <FilterMobileWrapper>
        <FilterBar name={name} isModal>
          {children}
        </FilterBar>
      </FilterMobileWrapper>
      <MobileButtonsRow>
        <MobileButton onClick={handleModalClose}>
          {isLoading || isNewFilterSelected ? (
            <LoadingSpinner color={Core.icon.inverse} size="small" />
          ) : (
            <StrictLocalMsg
              defaultMessage="Show {resultsCountNumber} matches"
              description={{
                text: "Mobile button text to show how many matches user gonna see after applying filters",
                img: "https://cdn.faire.com/fastly/adb5642ecc19754748e79acc1d308475bacbea0c9bf3a9b7f349c7bcd8b3e596.png",
              }}
              values={{
                resultsCountNumber: resultsCount,
              }}
            />
          )}
        </MobileButton>
      </MobileButtonsRow>
    </Modal>
  );
};

const MobileButtonsRow = styled(Row)`
  position: absolute;
  width: 100%;
  bottom: 0;
  background: white;
  padding: ${getSpacing("2x")};
  border-top: 1px solid ${Core.border.muted};
  z-index: 11;
`;

const MobileButton = styled(Button)`
  width: 100%;
`;

const FilterMobileWrapper = styled(Column)`
  width: 100%;
  height: 100%;
  overflow: auto;
  margin-bottom: ${getSpacing("6x")};

  ${responsiveMediaQueries.mobile} {
    margin-bottom: ${getSpacing("2x")};
    padding: ${getSpacing(0, 12)};
  }
`;
